import React from 'react';
import { ApplicationEditLayoutTemplate } from 'themes/layouts';

function ApplicationEditLayout(props) {
    return <ApplicationEditLayoutTemplate {...props} />;
}

export default ApplicationEditLayout;
